import { TransferOrderStatus } from '../../graphql'

export const CANCELLABLE_STATUSES = new Set( [
	TransferOrderStatus.Pending,
	TransferOrderStatus.Approved,
	TransferOrderStatus.InTransit,
] )

export type StatusChipColor = 'default' | 'warning' | 'success' | 'error' | 'info' | 'primary' | 'secondary'

export const STATUS_CHIP_COLOR: Record<TransferOrderStatus, StatusChipColor> = {
	[ TransferOrderStatus.Pending ]: 'warning',
	[ TransferOrderStatus.Approved ]: 'info',
	[ TransferOrderStatus.Rejected ]: 'error',
	[ TransferOrderStatus.InTransit ]: 'primary',
	[ TransferOrderStatus.Completed ]: 'success',
	[ TransferOrderStatus.Cancelled ]: 'default',
}

export const STATUS_LABEL: Record<TransferOrderStatus, string> = {
	[ TransferOrderStatus.Pending ]: 'Pending',
	[ TransferOrderStatus.Approved ]: 'Approved',
	[ TransferOrderStatus.Rejected ]: 'Rejected',
	[ TransferOrderStatus.InTransit ]: 'In Transit',
	[ TransferOrderStatus.Completed ]: 'Completed',
	[ TransferOrderStatus.Cancelled ]: 'Cancelled',
}
